import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Card = styled(Box)`
  ${({ theme }) => css`
    border: 1px solid #73A49F;
    border-radius: 10px;
    padding: 10px;
    background: ${theme.colors.lightest};
    display: flex;
    align-items: center;
    gap: 20px;
    transition: all 0.2s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
  `}
`

export const IconContainer = styled(Box)`
  ${() => css`
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: #F0F0F0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  `}
`

export const CardContent = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex: 1;
    gap: 24px;
    min-width: 0;

    @media (max-width: ${theme.screenSizes.laptop}) {
      flex-wrap: wrap;
      gap: 16px;
    }
  `}
`

export const LeftSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
`

export const TitleRow = styled(Box)`
  display: flex;
  align-items: center;
`

export const InfoRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const SimulationNumber = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 600;
    color: ${theme.colors.secondary};
    user-select: none;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
  `}
`

export const SimulationType = styled.span`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 400;
    color: ${theme.colors.gray.dark};
    user-select: none;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
  `}
`

export const Separator = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.border.light};
    font-size: 14px;
    user-select: none;
  `}
`

export const CurrencyValue = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 500;
    color: ${theme.colors.gray.dark};
    user-select: none;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
    white-space: nowrap;
  `}
`

export const RightSection = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: fit-content;
`

export const DateValue = styled.span`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 400;
    color: ${theme.colors.gray.dark};
    user-select: none;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
    white-space: nowrap;
  `}
`

export const ActionsContainer = styled(Box)`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const ActionButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    background: ${theme.colors.lightest};
    cursor: pointer;
    transition: all 0.2s ease;
    color: ${theme.colors.secondary};
    flex-shrink: 0;

    &:hover {
      background: ${theme.colors.primary};
      color: ${theme.colors.lightest};
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  `}
`
